import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, getFormValues } from 'redux-form';

import ContentCard from '../common/template/contentCard';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';

import {
    setModoTela,
    initForm
} from './unidadeMedidaActions';

let UnidadeMedidaForm = props => {

    const formulario = props.formularioValues || {};
    const readOnly = props.excluir ? 'readOnly' : '';

    return (
        <ContentCard>

            <Form event={props.handleSubmit}>

                <ContentCardBody>

                    <Row>

                        <Field
                            name='nome'
                            component={LabelAndInput}
                            label='Nome *'
                            placeholder='Informe'
                            cols='12 9 9 9'
                            readOnly={readOnly}
                        />

                        <Field
                            name='sigla'
                            component={LabelAndInput}
                            label='Sigla *'
                            placeholder='Informe'
                            cols='12 3 3 3'
                            maxLength={20}
                            readOnly={readOnly}
                        />

                    </Row>

                </ContentCardBody>

                <ContentCardFooter>

                    <Row alignCenter>

                        <Grid cols='6 6 4 3'>

                            <Button
                                text='Voltar'
                                type='light'
                                icon='fa fa-chevron-left'
                                event={() => props.setModoTela('lista')}
                            />

                        </Grid>

                        <Grid cols='6 6 4 3'>

                            {props.excluir &&
                                <Button
                                    text='Excluir'
                                    submit
                                    type='danger'
                                    icon='fa fa-trash'
                                />
                            }

                            {!props.excluir &&
                                <Button
                                    text='Salvar'
                                    submit
                                    type='success'
                                    icon='fa fa-check'
                                />
                            }

                        </Grid>

                    </Row>

                </ContentCardFooter>

            </Form>

        </ContentCard>
    );
};

UnidadeMedidaForm = reduxForm({
    form: 'unidadeMedidaForm',
    destroyOnUnmount: false
})(UnidadeMedidaForm);

const mapStateToProps = state => ({
    sessao: state.auth.usuario,
    formularioValues: getFormValues('unidadeMedidaForm')(state),
    registro: state.unidadeMedida.registro
});

const mapDispatchToProps = dispatch => bindActionCreators({
    setModoTela,
    initForm
}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UnidadeMedidaForm);